import { ThunkAction } from 'redux-thunk'
import { AnyAction } from 'redux'
import { RootState } from 'constants/interfaces'
import { httpAuth } from 'config/apiClient'
import endpoints from 'constants/endpoints'

export const getJobActionReference =
  (action_reference: string): ThunkAction<Promise<any | null>, RootState, unknown, AnyAction> =>
  async () => {
    try {
      const { data } = await httpAuth.get(endpoints.jobActionReference, { params: { action_id: action_reference } })
      return data
    } catch (error) {
      console.log(`getJobActionReference failed due ${error}`)
      return null
    }
  }
